export default {
    'Integral': 'BXH',
    'Schedule': 'Lịch',
    'Player': 'BXH cầu thủ',
    'All': 'Tất cả',
    'footballer': 'Cầu thủ',
    'team': 'Đội',
    'assist': 'Kiến tạo',
    'goal': 'Bàn thắng',
    'TopCcorer': 'Vua phá lưới',
    'assists': 'BXH kiến tạo',
    'Sai': 'MP',
    'Win/draw/lose': 'B / X / H',
    'Win': 'Thắng',
    'Lose': 'Thua',
    'in/out': 'F/A',
    'integration': 'Pts',
    'confirm': 'Xác nhận',
    'cancel': 'Hủy',
    'Group Stage': 'Vòng bảng',
    'mainTitle': 'World Cup Bóng rổ FIBA 2023',
    'Year': 'Năm',
    'Month': 'Tháng',
    'Day1': 'Ngày',
    'Day': 'Ngày',
    'Hour': 'Giờ',
    'Minute': 'Phút',
    'Second': 'Giây',
    'HT': 'HT',
    'QT': 'QT',
    'Corner': 'Phạt góc',
    '90Min': '90 phút',
    'Promotion zone': 'Khu đi tiếp',
    'undetermined': 'Khu bị loại',
    'thirdGroup': 'Hạng 3 vòng bảng',
    'firstGroup': 'Vòng bảng',
    'secondGroup': 'Vòng bảng 2',
    'rankGroup': 'Xếp hạng 17-32',
    'rankNum': 'Trận',
    'rank1': 'Chung kết',
    'rank2': 'Hạng 5-8',
    'rank21': 'Hạng 5-8',
    'rank3': 'Tứ kết',
    'rank4': 'Bán kết',
    'rank5': 'Chung kết',
    'rank6': 'Tranh hạng 3',
    'rank7': 'Xếp hạng',
    'rank8': 'Chung kết hạng 5',
    'rank9': 'Chung kết hạng 7',
    'Final': 'Chung kết',
    'tbd': 'TBD',
    'round16': '1/16',
    'round8': '1/8',
    'round4': 'Tứ kết',
    'roundSemiFinal': 'Bán / C.kết',
    'conntdown': 'Đếm ngược Chung kết World Cup',
    'worldcup': 'Đếm ngược World Cup',
    'nodata': 'Không Có Đữ Liệu',
    'Finish': 'Kết thúc',
    'mute': 'Tắt tiếng',
    'unmute': 'Bật tiếng',
    'openMini': 'PIP',
    'sd': 'SD',
    'hd': 'HD',
    'fullscreen': 'Toàn màn hình',
    'cancelFullscreen': 'Thoát toàn màn hình',
    'empty': 'Không Có Dữ Liệu',
    'loginOut': 'Đăng nhập đã hết hạn.',
    'refresh': 'Làm mới'
}